import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from './typeguards'
import { useCallback } from 'react'
import qs from 'qs'

interface TransitionOptions {
  shallow?: boolean
  locale?: string | false
  scroll?: boolean
  unstable_skipClientCache?: boolean
}

type Options = {
  isReplace?: boolean
  routerPushOptions?: TransitionOptions
}
/**
 * 통합주문 도메인 내에서의 페이지 이동 util hook
 */
const useNavigateInternalUrl = () => {
  /**
   * 통합주문 도메인 내에서의 페이지 이동 util 함수.
   * - App: yaNative.wv
   * - Web: window.location
   * @param path 이동할 url path
   * @param isReplace history replace 여부 (useModalHash 에서 이동 시 사용)
   * @param routerPushOptions 기존 호출부 호환용 옵션. Web 문서 이동에서는 사용하지 않는다.
   */
  const navigateInternalUrl = useCallback((path: string, options?: Options) => {
    const yaNative = getYaNative()

    if (isNative(yaNative)) {
      const [urlPath, params] = path.split('?')
      yaNative.wv({
        method: 'get',
        url: `${window.location.origin}${urlPath}`,
        ...(params && { params: qs.parse(params, { depth: 0 }) as any }),
      })
    } else {
      if (options?.isReplace) {
        window.location.replace(path)
        return
      }
      window.location.href = path
    }
  }, [])

  return { navigateInternalUrl }
}

export default useNavigateInternalUrl
